import Pendo from '@cjdev-internal/pendo/dist/pendo.min.js';
const env = process.env.NODE_ENV;

export default (id, email, isInternal = true) => {
  const initializer = Pendo.install(env);
  initializer.initialize(id, email, isInternal);
};
